module.exports = require("fs");


/*****************
 ** WEBPACK FOOTER
 ** external "fs"
 ** module id = 2
 ** module chunks = 0
 **/